import { Button, Input } from 'antd';
import { FC, useState } from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import { CloseOutlined } from '@ant-design/icons';
import FormItem from 'components/FormItem';
import { ModalHandler } from 'components/Modal';
import VerifyCodeSend from 'components/VerifyCodeSend';
import { __ } from 'utils/i18n';
import styles from './style.scss';

export interface SafeVerifyData {
    verify_code: string;
    grant_type: 'emailCode' | 'phoneCode'; // 用于登录时传递grant_type
}

interface SafeVerifyProps extends ModalHandler {
    type: 'phone' | 'email';
    tel_code?: string;
    username: string;
    onSubmit: (data: SafeVerifyData) => void;
}

const SafeVerify: FC<SafeVerifyProps> = ({ tel_code, type, username, onSubmit, dismiss }) => {
    const $formutil = useForm<SafeVerifyData>();
    const [loading, setLoading] = useState(false);
    const isEmail = type === 'email';
    const handleSubmit = async ev => {
        ev.preventDefault();

        try {
            setLoading(true);

            await onSubmit({ ...$formutil.$params, grant_type: isEmail ? 'emailCode' : 'phoneCode' });
        } catch (err) {}

        setLoading(false);
    };

    return (
        <form className={styles.root} noValidate onSubmit={handleSubmit}>
            <h3 className="mb-4">{isEmail ? __('邮箱验证') : __('手机验证')}</h3>
            <div className={styles.close} onClick={() => dismiss()}>
                <CloseOutlined />
            </div>
            <div>
                <p className={styles.desc}>
                    {type === 'email' ? __('请输入登录邮箱的验证码') : __('请输入登录手机号的验证码')}
                </p>
                <FormItem label={null}>
                    <Input value={isEmail ? `${username}` : `+${tel_code} ${username}`} disabled />
                </FormItem>
                <VerifyCodeSend
                    label={null}
                    username={username}
                    name="verify_code"
                    process="verify_code_signin"
                    type={type}
                    tel_code={tel_code}
                    line
                />
            </div>
            <div className="mt-2">
                <Button
                    className={styles.btnSubmit}
                    type="primary"
                    size="large"
                    htmlType="submit"
                    loading={loading}
                    disabled={!$formutil.$params.verify_code}>
                    {loading ? __('正在登录') : __('登 录')}
                </Button>
            </div>
        </form>
    );
};

const SafeVerifyForm = withForm(SafeVerify);

export default SafeVerifyForm;
